import React from 'react';
import { Modal, Carousel } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const IssueSliderModal = ({ show, onHide, issues }) => {
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('ko-KR', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
        });
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'REPORTED': return <span className="badge bg-danger bg-opacity-10 text-danger">신고됨</span>;
            case 'IN_PROGRESS': return <span className="badge bg-warning bg-opacity-10 text-warning">처리중</span>;
            case 'RESOLVED': return <span className="badge bg-primary bg-opacity-10 text-primary">해결 완료</span>;
            case 'WAITING': return <span className="badge bg-secondary bg-opacity-10 text-secondary">처리 대기 중</span>;
            default: return <span className="badge bg-light text-dark border">{status}</span>;
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fw-bold fs-5">이슈 상세</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-2">
                {issues && issues.length > 0 ? (
                    <Carousel indicators={true} interval={null} variant="dark" className="issue-carousel">
                        <style>{`
                            .issue-carousel .carousel-control-prev,
                            .issue-carousel .carousel-control-next {
                                width: 5%;
                            }
                            .issue-carousel .carousel-indicators {
                                margin-bottom: 0;
                            }
                        `}</style>
                        {issues.map((issue) => (
                            <Carousel.Item key={issue.id} className="pb-4">
                                <div
                                    className="p-4 border rounded-4 bg-light mx-4 mb-3"
                                    onClick={() => navigate(`/issues/${issue.id}`)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <h5 className="fw-bold mb-0 text-truncate pe-2">{issue.title}</h5>
                                        <div style={{ flexShrink: 0 }}>{getStatusBadge(issue.status)}</div>
                                    </div>
                                    <div className="small text-muted mb-3 fw-medium">
                                        <i className="bi bi-geo-alt-fill me-1 text-primary"></i>
                                        {issue.facility?.name} {issue.section?.name && `> ${issue.section.name}`}
                                    </div>
                                    <div className="bg-white p-3 rounded-3 text-muted small mb-3 border shadow-sm" style={{ minHeight: '80px', whiteSpace: 'pre-wrap' }}>
                                        {issue.description || '내용 없음'}
                                    </div>
                                    <div className="d-flex justify-content-between align-items-end small text-secondary">
                                        <div>
                                            <div className="mb-1"><i className="bi bi-clock me-1"></i> {formatDate(issue.createdAt)}</div>
                                            {issue.reporter?.name && (
                                                <div><i className="bi bi-person-fill me-1"></i> {issue.reporter.name}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                ) : (
                    <div className="text-center py-5 text-muted bg-light rounded-4">해당 기간에 등록된 이슈가 없습니다.</div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default IssueSliderModal;
